<div class="static-container">
  <h4>
    FAQ
  </h4>
  <mat-tab-group>
    <mat-tab label="General">
      <div class="tab-wrapper">
        <div class="tab-content">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What are Record Pools and why join Ours?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Record Pools are a promotional music service for professional DJs where the content is delivered
              downloaded in MP3 format. DJ Mixing Lab provides professional DJs the best
              platform to find and download all the latest music.</p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What music genres are available for download?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="content-title">Genres</p>
            <ol class="gray-text">
              <li>Acapella</li>
              <li>Afro Beat</li>
              <li>Afro House</li>
              <li>Bachata</li>
              <li>Big Room - Edm</li>
              <li>Booty Music</li>
              <li>Brazilian Funk</li>
              <li>Country</li>
              <li>Cubaton</li>
              <li>Cumbia – Vallenato</li>
              <li>Dance</li>
              <li>Dance Classics</li>
              <li>Deep House - Lounge</li>
              <li>Dembow</li>
              <li>Disco – Funk</li>
              <li>Electro - Future - Progressive House</li>
              <li>Electro Pop</li>
              <li>Freestyle</li>
              <li>Guaracha</li>
              <li>Hip-Hop</li>
              <li>Hip-Hop Classics</li>
              <li>House</li>
              <li>Latin Dance</li>
              <li>Latin House</li>
              <li>Latin Moombahton</li>
              <li>Latin Pop</li>
              <li>Latin Tech</li>
              <li>Latin Trap</li>
              <li>Merengue – Mambo</li>
              <li>Mixes</li>
              <li>Moombahton</li>
              <li>Nu Disco</li>
              <li>Oldies</li>
              <li>Pop</li>
              <li>Pop Classics</li>
              <li>R&B</li>
              <li>R&B Classics</li>
              <li>Reggae - Dancehall – Soca</li>
              <li>Reggaeton</li>
              <li>Reggaeton Classics</li>
              <li>Regional Mexican</li>
              <li>Retro - New Wave</li>
              <li>Rock</li>
              <li>Rock Classics</li>
              <li>Salsa</li>
              <li>Samples</li>
              <li>Samples – Loops</li>
              <li>Segway - Word Tone Play</li>
              <li>Soulful House</li>
              <li>Spanish Rock</li>
              <li>Tech – Minimal</li>
              <li>Tribal House</li>
              <li>Trip-Hop Breakbeats</li>
              <li>Tropical House</li>
            </ol>
            <p class="content-title">Sub-Genres</p>
            <ol class="gray-text">
              <li>Clap Intro</li>
              <li>Hype Edit</li>
              <li>Mashup</li>
              <li>Open Show Intro</li>
              <li>Party Break</li>
              <li>Remix – Edit</li>
              <li>Transition Down</li>
              <li>Transition Up</li>
              <li>Twerk</li>
            </ol>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What are the types of content delivery available?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Our content is delivered through downloads as MP3 files.</p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How often is new content available?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">We release music files daily.</p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  Can downloaded music be kept?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Yes.</p>
          </mat-expansion-panel>

<!--          <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--              <mat-panel-title>-->
<!--                <div class="panel-title">-->
<!--                  Where is your download history? / ??????-->
<!--                </div>-->
<!--              </mat-panel-title>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p class="gray-text">Find your downloaded music history. <a routerLink="/library">Here</a></p>-->
<!--          </mat-expansion-panel>-->

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What is the downloading limit?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">We have a limit of 3 downloads per file to prevent users sharing their account.</p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to submit music?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Record Labels, Artists, Re-Mixers and Editors can submit tracks for consideration. <a routerLink="/contact-us">Here</a></p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to submit a DMCA request?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Please submit a DMCA form <a routerLink="/dmca">Here</a></p>
          </mat-expansion-panel>



          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to contact us?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Approved members can contact us. <a routerLink="/contact-us">Here</a></p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to join?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Professional DJs can apply for membership. <a routerLink="/apply">Here</a></p>
          </mat-expansion-panel>
        </div>
      </div>

    </mat-tab>
    <mat-tab label="Billing">
      <div class="tab-wrapper">
        <div class="tab-content">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What is the membership cost?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Subscription pricing <a routerLink="/apply">Here</a></p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What payment forms do we accept?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">All Major Credit Cards.</p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to change or cancel your membership plan?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Change or cancel your membership plan. <a routerLink="/profile">Here</a></p>
          </mat-expansion-panel>


          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to update billing information?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Update Billing Information. <a routerLink="/profile">Here</a></p>
          </mat-expansion-panel>



          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to dispute billing issues or request a refund?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Create a support ticket. <a routerLink="/contact-us">Here</a></p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to renew membership?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">To renew membership. Please put your login credentials <a [routerLink]="userStore.user() ?  '/profile' : '/login'">Here</a>.
              After this please select the subscription plan.
            </p>
          </mat-expansion-panel>



          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  When do memberships automatically bill?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Depending on the membership type. Monthly, Quarterly or Yearly.</p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What if I can’t purchase or change my membership plan?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Create a support ticket. <a routerLink="/contact-us">Here</a></p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  Where to find your invoices?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">Find your invoice Here. <a routerLink="/profile">Here</a></p>
          </mat-expansion-panel>


        </div>
      </div>
    </mat-tab>

    <mat-tab label="Technical">
      <div class="tab-wrapper">
        <div class="tab-content">

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What is the format and quality of the music library?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Our music library has the highest quality of MP3’s at 320kbps. All Music Files have the Artist, Title, Bpm,
              Key, Genre properly filled inside the ID3 Meta Tag. Our Library is also Serato ready with Cue Points and Beatgrids.
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What music software are your files compatible with?

                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Our music library is compatible with all DVS software platforms including Serato, Rekordbox and Traktor.
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  We use an intuitive 4 step search engine system:


                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ol class="gray-text">
              <li>Search – Direct search by artist name or title for music files.</li>
              <li>Categories – Genre collection is narrowed down to a specific type of format. (i.e. Dance, Latin and Urban.)</li>
              <li>Genres – Specific music genre list.</li>
              <li>Sub-Genres – Edits and DJ Tools of genres.</li>
            </ol>
          </mat-expansion-panel>


          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to change your password?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Change your password. <a routerLink="/profile">Here</a>
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to request account deletion?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Submit cancellation request <a routerLink="/contact-us">Here</a>
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  Can’t download music with an active membership?

                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Please submit support ticket <a routerLink="/contact-us">Here</a>
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to submit a website error?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Please submit website errors <a routerLink="/contact-us">Here</a>
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  How to reset browser cache?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <p class="content-title">In Safari</p>
            <ol class="gray-text">
              <li>Click on the Safari drop-down menu and select Preferences.</li>
              <li>Click the Advanced tab. Select the Show Develop menu in menu bar checkbox and close the Preferences window.</li>
              <li>Select the Develop drop-down menu. Click Empty Cache.</li>
              <li>Note: You may want to also clear your browser history.</li>
            </ol>
            <p class="content-title">In Chrome</p>
            <ol class="gray-text">
              <li>Click: the More icon (three vertical dots) in the top-right corner of the browser window.</li>
              <li>Hover: over More tools (if you're on a computer).</li>
              <li> Select: Clear browsing data from the dropdown menu.</li>
              <li>Choose: a Time range from the dropdown menu at the top of the dialog box. "All time" will clear everything, while other options like "Last hour" or "Last 24 hours" clear a specific period.</li>
              <li>Check: the box for Cached images and files. You can also check other boxes like "Cookies and other site data" if you want to clear those as well.</li>
              <li>Click: the Clear data button to complete the process.</li>
            </ol>
            <p class="content-title">In Firefox</p>
            <ol class="gray-text">
              <li>In the Menu bar at the top of the screen, click Firefox and select Preferences.</li>
              <li>Select the Privacy &amp; Security panel.</li>
              <li>In the Cookies and Site Data section, click Clear Data.</li>
              <li>Remove the check mark in front of Cookies and Site Data.</li>
              <li>With Cached Web Content check marked, click the Clear button.</li>
            </ol>
          </mat-expansion-panel>


          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-title">
                  What is the Cookie Policy?
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="gray-text">
              Please read about our Cookie Policies <a routerLink="/cookie-policy">Here</a>
            </p>
          </mat-expansion-panel>


        </div>
      </div>

    </mat-tab>
  </mat-tab-group>

<!--  <p class="gray-text ps-4">-->
<!--    Launched in 2025, DJ Mixing Lab has rapidly risen to become the ultimate destination for professional DJs worldwide. As the premier subscription-based digital record pool, we power thousands of DJs every day with the freshest, most electrifying new music.-->
<!--  </p>-->
<!--  <p class="gray-text ps-4">-->
<!--    At DJ Mixing Lab, we don’t just serve music—we curate the vibe. Our team is laser-focused on selecting only the most mix-ready, club-crushing tracks, from exclusive edits to must-have mixshow versions. It’s quality over quantity, every time.-->
<!--  </p>-->
<!--  <p class="gray-text ps-4">-->
<!--    That’s why top DJs in the industry’s biggest markets trust DJ Mixing Lab to keep their sets sharp and their crowds moving. With membership reserved exclusively for professional DJs, we ensure our music fuels only those who set the trends and own the night.-->
<!--  </p>-->
</div>




